import React, { ReactNode } from 'react';

export function VisuallyHidden({ children }: { children?: ReactNode }) {
  if (!children) return null;
  return <span className="visually-hidden">{children}</span>;
}
